'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Skill;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'skill';

function Skill(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      selected = _ref.selected;

  var className = [CLASS_NAME, selected ? 'selected' : null].join(' ');

  return _react2.default.createElement(
    'div',
    {
      className: className,
      onClick: onChange
    },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'label',
        null,
        label
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Skills/Skill.js
// module id = 1239
// module chunks = 0